import styled from "@emotion/styled";
import EmptyBg from "components/main/emptyBg";

export const CustomEmpty = styled(EmptyBg)`
  > div > img {
    width: 315px;
  }
`;
